import React, { PureComponent } from 'react';
import { Icon } from 'antd';
import styles from './index.module.less';
import RightContent from './RightContent';

export default class GlobalHeader extends PureComponent {
  /* eslint-disable*/
  render() {
    const { collapsed, isMobile, toggleMenuCollapse } = this.props;
    return (
      <div className={styles.header}>
        <span className={styles.trigger} onClick={toggleMenuCollapse}>
          <Icon type={collapsed ? 'menu-unfold' : 'menu-fold'} />
        </span>
        <RightContent {...this.props} />
      </div>
    );
  }
}
